// extracted by mini-css-extract-plugin
module.exports = {"linkDiv":"Menu_linkDiv__1hM_3","menu":"Menu_menu__31JE0"};